import React from 'react';
import { MessageCircleIcon, GraduationCapIcon, SlackIcon, GlobeIcon } from 'lucide-react';
const UseCaseCard = ({
  icon,
  title,
  description
}) => {
  return <div className="bg-slate-900 p-6 rounded-xl border border-slate-700 hover:border-orange-500/50 transition-all duration-300 h-full flex flex-col" data-id="element-435">
      <div className="bg-orange-500/10 w-14 h-14 rounded-lg flex items-center justify-center mb-4" data-id="element-436">
        {icon}
      </div>
      <h3 className="text-lg font-bold text-white mb-3" data-id="element-437">{title}</h3>
      <p className="text-slate-400 flex-grow" data-id="element-438">{description}</p>
    </div>;
};
const UseCases = () => {
  const cases = [{
    icon: <GraduationCapIcon size={24} className="text-orange-500" data-id="element-439" />,
    title: 'Interactive Multi-Modal Onboarding',
    description: 'Multi-step onboarding with voice input, document upload, and real-time AI validations. Boost UX and conversion rates.'
  }, {
    icon: <GlobeIcon size={24} className="text-orange-500" data-id="element-440" />,
    title: 'Multi-Channel Data Capture',
    description: 'Deploy forms across WhatsApp, email, and web—letting users stay in their preferred channel. Higher engagement and conversion.'
  }, {
    icon: <MessageCircleIcon size={24} className="text-orange-500" data-id="element-441" />,
    title: 'Conversational Lead Qualification',
    description: 'AI agents that chat with prospects, ask qualifying questions, and fill forms naturally—boosting conversion and user experience.'
  }, {
    icon: <SlackIcon size={24} className="text-orange-500" data-id="element-442" />,
    title: 'Slack Upsells and Expense Reports',
    description: 'Upsell via Slack or streamline expense reports—employees send receipts via Slack to auto-fill forms. Better conversion and data quality.'
  }];
  return <section className="w-full bg-slate-950 py-20 border-t border-slate-800" id="use-cases" data-id="element-443">
      <div className="container mx-auto px-4" data-id="element-444">
        <div className="text-center mb-12" data-id="element-445">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-446">
            Example Use Cases
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-447">
            See how organizations are replacing static forms with conversational
            AI agents that feel human and interactive.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-448">
          {cases.map((useCase, index) => <UseCaseCard key={index} icon={useCase.icon} title={useCase.title} description={useCase.description} data-id="element-449" />)}
        </div>
      </div>
    </section>;
};
export default UseCases;